import { render, staticRenderFns } from "./managerReviewHome.vue?vue&type=template&id=bdc3be94"
import script from "./managerReviewHome.vue?vue&type=script&lang=js"
export * from "./managerReviewHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports